import React from 'react'
import CoverLetterProvider, { useCoverLetter } from './CoverLetterProvider'
import { TemplateProvider } from '~/lib/pdf'
import { TranslationProvider } from '~/components/shared/TranslationProvider'
import translations from './locales.json'
import { templates, templateStyle, templateSupportedStyles } from './templates'

const StandaloneViewer = ({ locale, ...props }) => {
  const { template_settings, template_index } = props
  const defaultStyle = template_settings
    ? {
        ...templateStyle,
        [`template-${template_index}`]: template_settings,
      }
    : templateStyle
  const templateProps = {
    templates,
    defaultStyle,
    templateSupportedStyles,
    template_index,
  }

  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope="javascript.components.CoverLetterBuilder"
    >
      <TemplateProvider {...templateProps}>
        <CoverLetterProvider locale={locale} {...props}>
          <div id="resume-pdf-preview" className="relative md:flex-grow">
            <div className="w-full md:sticky md:left-0 md:top-0 md:h-screen">
              <PdfViewer {...props} />
            </div>
          </div>
        </CoverLetterProvider>
      </TemplateProvider>
    </TranslationProvider>
  )
}
export default StandaloneViewer

const PdfViewer = ({ HideToolBar }) => {
  const {
    pdf: { url, loading },
  } = useCoverLetter()

  const viewerUrl = HideToolBar
    ? `${url}#toolbar=0&navpanes=0`
    : `${url}#navpanes=0`

  if (loading) {
    return null
  }
  return (
    <iframe
      src={viewerUrl}
      className="h-full w-full"
      title="Resume Preview"
      frameBorder="0"
      loading="lazy"
    />
  )
}
